import { Injectable } from "@angular/core";
import * as moment from "moment";
import { ProductionTechnologiesRecipes } from "../services/service/DataProviders/ProductionTechnologiesRecipes";
import { Subject } from "rxjs";
import { take } from "rxjs/operators";
import * as _ from "lodash";
import { FormGroup } from "@angular/forms";
import { ProductionShopFloorWorkOrders } from "../services/service/DataProviders/ProductionShopFloorWorkOrders";
import { ProductionShopFloorWorkOrderItems } from "../services/service/DataProviders/ProductionShopFloorWorkOrderItems";
import { ProductionShopFloorWorkOrderItemIngredients } from "../services/service/DataProviders/ProductionShopFloorWorkOrderItemIngredients";
import { ProductionShopFloorWorkOrderItemOperations } from "../services/service/DataProviders/ProductionShopFloorWorkOrderItemOperations";
import { SettingsService } from "../services/settings.service";
import { TenantService } from "../services/tenant/tenant.service";
import { GeneralCustomProperties } from "../services/service/DataProviders/GeneralCustomProperties";

@Injectable({
  providedIn: "root",
})
export class Subproducts {
  public log$;
  private settings;
  private tree;
  private stores;
  private documentTypes = [];
  private po;

  private wos = [];

  constructor(
    private woService: ProductionShopFloorWorkOrders,
    private woProductsService: ProductionShopFloorWorkOrderItems,
    private woIngredientsService: ProductionShopFloorWorkOrderItemIngredients,
    private woOperationsService: ProductionShopFloorWorkOrderItemOperations,
    private settingsService: SettingsService,
    private tenantService: TenantService,
    private customPropService: GeneralCustomProperties,
  ) {
    this.log$ = new Subject();
  }

  subscribeForLog() {
    return this.log$.asObservable();
  }

  public storeRefDoc = false;
  async checkForRefDocProperty() {
    const refDoc = await this.customPropService.findRefDoc().pipe(take(1)).toPromise();
    this.storeRefDoc = _.has(refDoc, 'value[0].Code');
    console.log('storerefdoc', this.storeRefDoc)
    return true;
  }

  async processList(tree, settings: FormGroup, stores, documentTypes, po) {
    this.tree = tree;
    this.stores = stores;
    this.documentTypes = documentTypes;
    this.po = po;

    this.loadSettings(settings);
    await this.checkForRefDocProperty();

    for (let i = 0; i < this.tree.length; i++) {
      let tree = this.tree[i];
      // let masterNode = tree.getNodesOnLevel(0)[0];
      // console.log('masterNode', masterNode);

      // let successorsOfMasterNode = tree.getSuccessors(masterNode);

      // for (let j = 0; j < successorsOfMasterNode.length; j++) {
      //   let successor = successorsOfMasterNode[j];

      //   console.log('successor', successor);
      //   // console.log('Predecessor', tree.getPredecessor(successor));

      //   let succccs = tree.getSuccessors(successor);

      //   for (let k = 0; k < succccs.length; k++) {

      //     console.log('subsuccessors', tree.getSuccessors(succccs[k]));
      //   }

      // }


      // return true;

      await this.processOne(tree);
    }
  }

  async processOne(tree) {
    // console.log("processing tree", tree);
    // console.log("maxLevel", tree.maxLevel);
    // console.log("settings", this.settings);

    let productName = tree.getProductName();
    const tenant = this.tenantService.getTenant();

    try {
      //start transaction
      if(tenant.transaction) {
        let transaction = await this.woService.beginTransaction({
          model: "frontend",
          trackChanges: true,
        });
  
        this.woProductsService.setTransaction(transaction);
        this.woIngredientsService.setTransaction(transaction);
        this.woOperationsService.setTransaction(transaction);
      }

      let masterNode = tree.getNodesOnLevel(0);
      let createdWos = [];

      if (this.settings.group) {
        this.log$.next({
          message: productName + " - Групирам субпродуктите за всяко подниво.",
          type: "SUCCESS",
        });
        let groupeWo = true;
        createdWos = await this.createWo(tree, groupeWo);
      } else {
        this.log$.next({
          message: productName + " - Създавам отделно ПН за всеки субпродукт.",
          type: "SUCCESS",
        });
        let groupeWo = false;
        createdWos = await this.createWo(tree, groupeWo);
      }

      if(tenant.transaction) {
        //имай предвид дали се ползва транзакция или не
        await this.delay(this.defaultDelay);
        await this.woService.commitTransaction();
        this.woService.clearTransaction();
        this.woProductsService.clearTransaction();
        this.woIngredientsService.clearTransaction();
        this.woOperationsService.clearTransaction();
      }

      await this.changeWosState(createdWos);
    } catch (e) {
      let err = _.get(e, "error.error.message", "");

      if (err.length == 0) {
        err = _.get(e, "error", "");
      }
      this.woService.clearTransaction();
      this.woProductsService.clearTransaction();
      this.woIngredientsService.clearTransaction();
      this.woOperationsService.clearTransaction();
      this.log$.next({ message: productName + ": " + err, type: "ERR" });
      console.error(e);
    }

    setTimeout(() => {
      this.log$.next({
        message: "Приключвам обработката за продукт: " + productName,
        tree: tree,
        type: "SUCCESS",
      });
    }, 1000);
    return tree;
  }

  async changeWosState(createdWos) {
    for (let i = 0; i < createdWos.length; i++) {
      await this.delay(this.defaultDelay);

      const data = {
        State: this.settings.status,
      };

      if(!_.isNull(this.settings.userStatus)) {
        data['UserState'] = {
          '@odata.id': this.settings.userStatus['@odata.id']
        };
      }

      await this.woService.changeDocumentState(
        createdWos[i].Id, data, false).pipe(take(1)).toPromise();
    }
  }

  private defaultDelay = 200;
  private delay(ms: number) {
    console.time("delay");
    return new Promise(resolve => {
      setTimeout(() => {
        console.timeEnd("delay");
        resolve(true);
      }, ms)
  });
  }

  async createWo(tree, groupWos) {
    if (tree.maxLevel <= 1) {
      //продукта не е съставен
      return [];
    }

    let createdWos = [];

    for (let i = 1; i < tree.maxLevel; i++) {
      let productNodes = tree.getNodesOnLevel(i);

      if(this.settings.sumQuantities && groupWos) {
        //сумирани количества. Ако е дадена тази настройка приложението сумира количествата на еднаквите съставки
        const grouped = _.groupBy(productNodes, (n) => n.product["@odata.id"]);
        productNodes = _.map(grouped, (g) => {
          if(g.length > 1) {
            // console.log('dubliran', g);
            // сумирам количеството на всички и връщам първият
            const clone = _.clone(_.first(g));
            clone.quantity = _.sumBy(g, 'quantity');
            // console.log('clone', clone);
            return clone;
          }

          return _.first(g);
        })
      }

      console.log("level " + i, productNodes);

      let createdPo = null;

      for (let j = 0; j < productNodes.length; j++) {
        let node = productNodes[j];
        if (_.isNull(node.defaultTechnology)) {
          continue;
        }

        if (_.isNull(createdPo) || !groupWos) {
          //при първата сложна съставка го създавам
          createdPo = await this.woService
            .storeRecord(null, this.generatePoHeader(tree, node))
            .pipe(take(1))
            .toPromise();
          node.po = createdPo;
          createdWos.push(createdPo);
        }

        let lineOrderItem = (j + 1) * 10;
        await this.delay(this.defaultDelay);
        let createdItem = await this.woProductsService
          .storeRecord(null, this.generateItem(createdPo, lineOrderItem, node))
          .pipe(take(1))
          .toPromise();
        // console.log("createdItem", createdItem);

        for (let k = 0; k < node.defaultTechnology.Ingredients.length; k++) {
          let lineOrderIngredient = (k + 1) * 10;

          let ingredient = node.defaultTechnology.Ingredients[k];
          // console.log("ingredient", ingredient);
          await this.delay(this.defaultDelay);
          let createdIngredient = await this.woIngredientsService
            .storeRecord(
              null,
              this.generateIngredient(
                createdPo,
                createdItem,
                lineOrderItem.toString() + lineOrderIngredient.toString(),
                ingredient,
                node
              )
            )
            .pipe(take(1))
            .toPromise();
          // console.log("createdIngredient", createdIngredient);
        }

        //todo има проблем ще го коментирам с ITC
        for (let k = 0; k < node.defaultTechnology.Operations.length; k++) {
          let lineOrderOperation = (k + 1) * 10;

          let operation = node.defaultTechnology.Operations[k];
          await this.delay(this.defaultDelay);
          let createdOperation = await this.woOperationsService
            .storeRecord(
              null,
              this.generateOperation(
                createdPo,
                createdItem,
                lineOrderItem.toString() + lineOrderOperation.toString(),
                operation,
                node
              )
            )
            .pipe(take(1))
            .toPromise();
        }
      }
    }

    console.log("createdWos", createdWos);
    return createdWos;
  }

  private addRootPoNumber(tree, data, predecessor) {
    const rootPONumber = tree.getRootPONumber();
    if(this.storeRefDoc && !_.isNull(rootPONumber) && !_.isEmpty(rootPONumber)) {
      const parentPo = _.get(predecessor, 'po.DocumentNo', '');
      data['CustomProperty_ref_doc'] = {
        Value:rootPONumber,
        Description: {
          BG: _.isNull(parentPo) ? '' : parentPo
        }
      };
    }

    return data;
  }

  private generatePoHeader(tree, node) {

    let predecessor = null;
    let predecessors = tree.getPredecessor(node);

    let parentPnDocumentId = null;

    if (predecessors.length > 0) {
      predecessor = predecessors[0];
      if (!_.isNull(predecessor.po)) {
        parentPnDocumentId = predecessor.po.DocumentId;
      }
    }

    if (_.isNull(parentPnDocumentId)) {
      parentPnDocumentId = this.po.DocumentId;
    }

    if(!this.settings.linkParent) {
      //без връзка към родител
      parentPnDocumentId = null;
    }

    let documentType = _.isNull(this.settings.documentType) ?
      _.has(this.po, "DocumentType")
        ? _.get(this.po, "DocumentType")
        : null
      : {
        '@odata.id': _.get(this.settings.documentType, ['@odata.id'])
      };

    let data = {
      DocumentType: documentType,
      EnterpriseCompany: _.has(this.po, "EnterpriseCompany")
        ? _.get(this.po, "EnterpriseCompany")
        : null,
      EnterpriseCompanyLocation: _.has(this.po, "EnterpriseCompanyLocation")
        ? _.get(this.po, "EnterpriseCompanyLocation")
        : null,
      FromParty: _.has(this.po, "FromParty")
        ? _.get(this.po, "FromParty")
        : null,
      DocumentDate: _.has(this.po, "DocumentDate")
        ? _.get(this.po, "DocumentDate")
        : null,
      DueDate: _.has(this.po, "DueDate")
        ? _.get(this.po, "DueDate")
        : null,
      Parent: parentPnDocumentId
        ? {
          "@odata.id":
            "General_Documents_Documents(" + parentPnDocumentId + ")",
        }
        : null,
      // MasterDocument: _.has(this.po, "DocumentId")
      //   ? {
      //       "@odata.id":
      //         "General_Documents_Documents(" + _.get(this.po, "DocumentId") + ")",
      //     }
      //   : null,

      //тези не ги задавам защото може да има различни складове поредове
      // DefaultMaterialsStore: _.has(this.po, "DefaultMaterialsStore")
      //   ? _.get(this.po, "DefaultMaterialsStore")
      //   : null,
      // DefaultOutputStore: _.has(this.po, "DefaultOutputStore")
      //   ? _.get(this.po, "DefaultOutputStore")
      //   : null,
      Items: [],
      ItemIngredients: [],
    };

    data = this.addRootPoNumber(tree, data, predecessor);
    return data;
  }

  private generateItem(createdPo, lineOrder, node) {
    let item = {
      WorkOrder: {
        "@odata.id": createdPo["@odata.id"],
      },
      LineOrd: lineOrder,
      Product: _.has(node, "product")
        ? { "@odata.id": node.product["@odata.id"] }
        : null,
      ProducedQuantityUnit: _.has(node, "measurementUnit")
      ? { "@odata.id": node.measurementUnit["@odata.id"] }
      : null,
      Recipe: !_.isNull(node, "defaultTechnology")
        ? { "@odata.id": _.get(node, "defaultTechnology")["@odata.id"] }
        : null,
      OutputStore: this.getStore(
        _.get(node, "defaultTechnology.Store", null),
        this.settings.productsStore,
        _.get(node.product, "CustomProperty_StoreForProdOrder", null),
        _.get(this.po, "DefaultOutputStore", null)
      ),
      ProducedQuantity: _.has(node, "defaultTechnology.ProduceQuantity")
        ? _.get(node, "defaultTechnology.ProduceQuantity")
        : null,
      Operations: [],
      Notes: _.get(node, "defaultTechnology.Notes", null),
    };

    if(!_.has(item, 'ProducedQuantity.originalValue')) {
      item.ProducedQuantity.originalValue = item.ProducedQuantity.Value;
    }
    item.ProducedQuantity.Value = item.ProducedQuantity.originalValue * node.quantity;
    if(item.ProducedQuantity.Value < 0.001) {
      item.ProducedQuantity.Value = _.ceil(item.ProducedQuantity.Value, 3);
    }
    else {
      item.ProducedQuantity.Value = _.round(item.ProducedQuantity.Value, 3);
    }

    delete (item.ProducedQuantity.Unit);
    return item;
  }

  private generateOperation(
    createdPo,
    createdItem,
    lineOrder,
    operation,
    node
  ) {

    let oper = {
      WorkgroupResource: _.has(operation, "WorkgroupResource")  && !_.isNull(operation.WorkgroupResource)
        ? { "@odata.id": operation.WorkgroupResource["@odata.id"] }
        : null,
      WorkOrderItem: {
        "@odata.id": createdItem["@odata.id"],
      },
      LineOrd: lineOrder,
      Operation: _.has(operation, "Operation") && !_.isNull(operation.Operation)
        ? { "@odata.id": operation.Operation["@odata.id"] }
        : null,
      WaitTimeMinutes: _.has(operation, "WaitTimeMinutes")
        ? _.get(operation, "WaitTimeMinutes")
        : null,
      UseQuantity: _.has(operation, "UseQuantity")
        ? _.get(operation, "UseQuantity")
        : null,
      Tooling: _.has(operation, "Tooling") ? _.get(operation, "Tooling") : null,
      SetupTimeMinutes: _.has(operation, "SetupTimeMinutes")
        ? _.get(operation, "SetupTimeMinutes")
        : null,
      ScrapRate: _.has(operation, "ScrapRate")
        ? _.get(operation, "ScrapRate")
        : null,
      RunTimeMinutes: _.has(operation, "RunTimeMinutes")
        ? _.get(operation, "RunTimeMinutes")
        : null,
      OperationDescription: _.has(operation, "OperationDescription")
        ? _.get(operation, "OperationDescription")
        : null,
      Notes: _.has(operation, "Notes") ? _.get(operation, "Notes") : null,
      MoveTimeMinutes: _.has(operation, "MoveTimeMinutes")
        ? _.get(operation, "MoveTimeMinutes")
        : null,
      MinimumConcurrentStartTimeMinutes: _.has(
        operation,
        "MinimumConcurrentStartTimeMinutes"
      )
        ? _.get(operation, "MinimumConcurrentStartTimeMinutes")
        : null,
    };

    oper.UseQuantity.Value = oper.UseQuantity.Value * node.quantity;
    if(oper.UseQuantity.Value < 0.001) {
      oper.UseQuantity.Value = _.ceil(oper.UseQuantity.Value, 3);
    }
    else {
      oper.UseQuantity.Value = _.round(oper.UseQuantity.Value, 3);
    }

    delete oper.UseQuantity.Unit;
    return oper;
  }

  private generateIngredient(
    createdPo,
    createdItem,
    lineOrder,
    ingredient,
    node
  ) {
    let ing = {
      WorkOrder: {
        "@odata.id": createdPo["@odata.id"],
      },
      WorkOrderItem: {
        "@odata.id": createdItem["@odata.id"],
      },
      LineOrd: lineOrder,
      Material: _.has(ingredient, "Material")
        ? { "@odata.id": ingredient.Material["@odata.id"] }
        : null,
      UsedQuantityUnit: _.has(ingredient, "UsageUnit")
      ? { "@odata.id": ingredient.UsageUnit["@odata.id"] }
      : null,
      Store: this.getStore(
        _.get(ingredient, "Store", null),
        this.settings.materialsStore,
        _.get(ingredient, "Material.CustomProperty_StoreForProdOrder", null),
        _.get(this.po, "DefaultMaterialsStore", null)
      ),
      Operation:
        _.has(ingredient, "Operation") && !_.isNull(ingredient.Operation)
          ? { "@odata.id": ingredient.Operation["@odata.id"] }
          : null,
      UsedQuantity: _.has(ingredient, "UsageQuantity")
        ? _.get(ingredient, "UsageQuantity")
        : null,
      Notes: _.get(ingredient, 'Notes', null),
    };

    if(!_.has(ing, 'UsedQuantity.originalValue')) {
      ing.UsedQuantity.originalValue = ing.UsedQuantity.Value;
    }

    ing.UsedQuantity.Value = ing.UsedQuantity.originalValue * node.quantity;
    if(ing.UsedQuantity.Value < 0.001) {
      ing.UsedQuantity.Value = _.ceil(ing.UsedQuantity.Value, 3);
    }
    else {
      ing.UsedQuantity.Value = _.round(ing.UsedQuantity.Value, 3);
    }

    if(this.settingsService.tenant.name == 'Ilinden Ltd') {

      const orderNo = _.get(this.po, 'CustomProperty_No_Order.Value', '');
      const ingId = _.get(ingredient, 'Id', '');
      const pId = _.get(ingredient, 'Material.Id', '');

      //временно го махам това. Мисля че не е необходимо засега
      // ing['CustomProperty_ProductionAPP_UniqueKey'] = {
      //   Value: `${orderNo}/${ingId}/${pId}`
      // };
    }
    return ing;
  }

  private getStore(storeFromRecipe, defaultStore, cpStore, defaultStoreFromMainDocument) {
    let store = null;

    if (!_.isNull(defaultStore)) {
      store = defaultStore;
    } else if (!_.isNull(cpStore) && _.has(cpStore, 'ValueId')) {
      store = {
        '@odata.id': 'Logistics_Inventory_Stores(' + cpStore.ValueId + ')'
      };
    } else if (!_.isNull(storeFromRecipe)) {
        store = storeFromRecipe;
    } else {
      if (!_.isNull(defaultStoreFromMainDocument)) {
        store = defaultStoreFromMainDocument;
      }
    }

    if (!_.isNull(store)) {
      store = {
        "@odata.id": store["@odata.id"],
      };
    }

    return store;
  }

  private loadSettings(settings: FormGroup) {
    this.settings = JSON.parse(JSON.stringify(settings.value));
    this.settings.group = this.settings.group === "true" ? true : false;
    this.settings.status = this.getState(this.settings.status);
    this.settings.productsStore = this.getStoreId(this.settings.productsStore);
    this.settings.materialsStore = this.getStoreId(
      this.settings.materialsStore
    );
    this.settings.documentType = this.getDocumentType(this.settings.documentType);
    this.settings.userStatus = this.getUserStatus(this.settings.userStatus);
  }

  private getUserStatus(name) {
    if(!this.settings.documentType) {
      return null;
    }

    let states = _.get(this.settings.documentType, "UserStatuses", []);
    for (let i = 0; i < states.length; i++) {
      let s = states[i];
      let stateName = _.get(s, "UserStatusName.BG", "");

      if (stateName == name) {
        return s;
      }
    }

    return null;
  }

  private getDocumentType(documentType) {
    for (let i = 0; i < this.documentTypes.length; i++) {
      let d = this.documentTypes[i];
      let documentTypeName = _.get(d, "TypeName.BG", "");

      if (documentTypeName == documentType) {
        return d;
      }
    }

    return null;
  }

  private getStoreId(store) {
    for (let i = 0; i < this.stores.length; i++) {
      let s = this.stores[i];
      let storeName = _.get(s, "Name.BG", "");

      if (storeName == store) {
        return s;
      }
    }

    return null;
  }

  private getState(state) {
    let resState = "New";
    switch (state) {
      case "Нов": {
        resState = "New";
        break;
      }
      case "Планиран": {
        resState = "Planned";
        break;
      }
      case "Потвърден": {
        resState = "FirmPlanned";
        break;
      }
      case "Пуснат": {
        resState = "Released";
        break;
      }
      default: {
        resState = "New";
        break;
      }
    }

    return resState;
  }

  private getMaxRowNumber(recipe) {
    let maxRowNumber = 0;
    recipe.Ingredients.forEach((i) => {
      if (_.get(i, "LineOrd", 0) > maxRowNumber) {
        maxRowNumber = _.get(i, "LineOrd", 0);
      }
    });

    return maxRowNumber;
  }
}
